import { render } from "./Pause.vue?vue&type=template&id=350ff18c&scoped=true"
import script from "./Pause.vue?vue&type=script&lang=js"
export * from "./Pause.vue?vue&type=script&lang=js"

import "./Pause.vue?vue&type=style&index=0&id=350ff18c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350ff18c"]])

export default __exports__